import {type CheckoutCarRentalServiceOption, ServiceType} from '../../../domain/types';
import * as React from 'react';
import { useCallback } from 'react';
import {
  SpaceBetween,
  tk,
  ListItem,
  CollapsibleRoot,
  RadioGroup,
} from '@sunwebgroup/ui-components';
import { ListItemControl, StyledShowMore } from './CarsListView';
import { useIntl } from '@/intl';
import {useService} from '@/scopes/checkout/domain/hooks';
import { CarCard} from './CarContentView';
import {upgradeCar} from "../../../domain/actions";

export function UgradeCarsListView({ currentSelectedCar, setShowUpgradeCars }: { currentSelectedCar: CheckoutCarRentalServiceOption; setShowUpgradeCars: (value: boolean) => void; }) {
  const intl = useIntl();
  const { service, setServiceValue } = useService(ServiceType.CarRental);

  const { driverId: currentDriverIdSelected, value: currentSelectedCarValue } = currentSelectedCar;

  const handleValueChange = useCallback(
    (value: string) => {
      if (!service) return;
      if (!currentDriverIdSelected) return;
      setServiceValue(upgradeCar({ value, participantId: currentDriverIdSelected })(service));
      setShowUpgradeCars(false);
    },
    [setServiceValue, currentDriverIdSelected, setShowUpgradeCars, service]
  );

  if (!service) return null;

  const { carLists } = service;

  if (!carLists || carLists.length === 0) return null;

  const availableOptionsToUpgrade = carLists.find(({ selectedValue }) => selectedValue === currentSelectedCarValue)?.availableOptionsToUpgrade;

  if (!availableOptionsToUpgrade || availableOptionsToUpgrade.length === 0) return null;
  return (
    <CollapsibleRoot open>
      <RadioGroup.Root>
        <StyledShowMore
          openLabel={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_show_more' })}
          closeLabel={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_show_less' })}
          buttonTriggerHierarchy="secondary"
        >
          <SpaceBetween direction="y" spacing={tk('spacing_sm')}>
            { availableOptionsToUpgrade?.map((option) => {
              const { value } = option;
              return (
                <ListItem.Root key={value} onClick={() => handleValueChange(value)}>
                  <ListItemControl>
                    <RadioGroup.Item value={value} />
                  </ListItemControl>
                  <ListItem.Content>
                    <CarCard {...option} />
                  </ListItem.Content>
                </ListItem.Root>
              );
            })}

          </SpaceBetween>
        </StyledShowMore>
      </RadioGroup.Root>
    </CollapsibleRoot>
  );
}
